import React, { useState } from "react";
import { Divider, Form, Input, DatePicker, InputNumber, Typography } from "antd";
import axios from "axios";
import { Error, Success } from "../../Messages/Messages";
import GeneralModal from "../../../serviceProvider/components/General.modal";
import MainButtonComp from "../../Buttons/MainButtonComp";
import { generalErrorAlert } from "../../GeneralErrorAlert";
import InlineNetPreview from "../../Payroll/InlineNetPreview";

import { useTranslation } from "react-i18next";
const { TextArea } = Input;
const { Text } = Typography;

const AddSalarySlipModal = ({ disabled, refreshParent, employee }) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Watched so the preview updates while the gross or a one-off payment is being typed.
  const brutto = Form.useWatch("brutto", form);
  const einmalzahlung = Form.useWatch("einmalzahlung", form);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFinish = async values => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/salary-slips/add`,
        {
          ...values,
          employee,
          startDate: values.startDate?.toISOString(),
          endDate: values.endDate?.toISOString()
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          refreshParent(res.data?.salarySlip);
          handleCancel();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  const items = (
    <Form form={form} layout="vertical" onFinish={handleFinish}>
      <Form.Item
        name="title"
        label={t("Title")}
        rules={[{ required: true, message: t("Title is required") }]}
      >
        <Input placeholder={t("Enter title")} />
      </Form.Item>

      <Form.Item
        name="startDate"
        label={t("Start Date")}
        rules={[{ required: true, message: t("Start Date is required") }]}
      >
        <DatePicker style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item
        name="endDate"
        label={t("End Date")}
        rules={[{ required: true, message: t("End Date is required") }]}
      >
        <DatePicker style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item name="description" label={t("Description")}>
        <TextArea rows={3} placeholder={t("Enter description")} />
      </Form.Item>

      <Divider orientation="start" plain>
        {t("Payroll")}
      </Divider>

      <Form.Item
        name="brutto"
        label={t("Gross salary (€)")}
        tooltip={t(
          "Leave empty to use the gross this period earns: the employee's monthly salary, or their hours worked times their rate, less unpaid leave."
        )}
      >
        <InputNumber
          min={0}
          step={100}
          style={{ width: "100%" }}
          placeholder={t("From employee")}
        />
      </Form.Item>

      <Form.Item
        name="einmalzahlung"
        label={t("One-off payment (€)")}
        tooltip={t(
          "Sonstiger Bezug such as Weihnachtsgeld; taxed separately under § 39b Abs. 3 EStG."
        )}
      >
        <InputNumber min={0} step={100} style={{ width: "100%" }} />
      </Form.Item>

      <InlineNetPreview employeeId={employee} values={{ brutto, einmalzahlung }} />
      <Text type="secondary" className="d-block mt-2">
        {t(
          "Lohnsteuer, Solidaritätszuschlag and Kirchensteuer follow the employee's Steuerklasse and the other Lohnsteuerabzugsmerkmale stored on their profile."
        )}
      </Text>
    </Form>
  );

  return (
    <>
      <MainButtonComp
        disabled={disabled && "Disabled"}
        text="Add Salary Slip"
        addBtn
        onClick={showModal}
      />
      <GeneralModal
        title={t("Add Salary Slip")}
        onOk={() => form.submit()}
        open={isModalOpen}
        okText={t("Save")}
        onCancel={handleCancel}
        items={items}
      />
    </>
  );
};

export default AddSalarySlipModal;
